import initialState from './initialState';
import * as types from '../actions/actionTypes';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function uniifyReducer(state = initialState.uniify, action) {
    switch (action.type) {
        case types.UNIIFY_INVITE_SUCCESS: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
